"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnvilSelectFooter = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../../");
var utils_1 = require("../utils");
var utilities_1 = require("../../../utilities");
exports.AnvilSelectFooter = react_1.default.memo(function (_a) {
    var actionName = _a.actionName, className = _a.className, selectAll = _a.selectAll, onActionClick = _a.onActionClick, onSelectAllClick = _a.onSelectAllClick, onSelectNoneClick = _a.onSelectNoneClick, closeSelectHandler = _a.closeSelectHandler, props = __rest(_a, ["actionName", "className", "selectAll", "onActionClick", "onSelectAllClick", "onSelectNoneClick", "closeSelectHandler"]);
    var AnvilSelectFooterClassNames = classnames_1.default('Select__footer w-100', className);
    var hasAction = !!(actionName && onActionClick);
    var handleOnActionClick = function (e) {
        closeSelectHandler();
        onActionClick(e);
    };
    var _b = react_1.default.useContext(utils_1.FocusContext), focusState = _b.focusState, focusDispatch = _b.focusDispatch;
    var actionFocus = focusState.actionFocus;
    var selectAllRef = react_1.default.useRef(null);
    var selectNoneRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var _a, _b;
        if (actionFocus === utils_1.FooterAction.SelectAll) {
            (_a = selectAllRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (actionFocus === utils_1.FooterAction.SelectNone) {
            (_b = selectNoneRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [actionFocus]);
    var handleKeyDown = function (e) {
        var _a, _b, _c;
        var target = e.target;
        if (e.key === utilities_1.keys.enter) {
            if (target.classList.contains('all')) {
                onSelectAllClick(e);
                focusDispatch({
                    type: utils_1.FocusActionType.SetFocus,
                    payload: { actionFocus: utils_1.FooterAction.SelectAll },
                });
                return;
            }
            if (target.classList.contains('none')) {
                onSelectNoneClick(e);
                focusDispatch({
                    type: utils_1.FocusActionType.SetFocus,
                    payload: { actionFocus: utils_1.FooterAction.SelectNone },
                });
                return;
            }
            if (actionName &&
                ((_a = target.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === actionName) {
                handleOnActionClick(e);
                return;
            }
        }
        if (e.key === utilities_1.keys.tab && e.shiftKey) {
            if ((selectAll &&
                !target.parentElement.previousElementSibling &&
                ((_b = target.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== actionName) ||
                (!selectAll && hasAction)) {
                e.preventDefault();
                utils_1.focusFirstOption(target, closeSelectHandler);
                return;
            }
        }
        if (e.key === utilities_1.keys.esc) {
            e.preventDefault();
            closeSelectHandler();
            return;
        }
        if (e.key === utilities_1.keys.tab && !e.shiftKey) {
            if ((actionName &&
                ((_c = target.textContent) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === actionName) ||
                (!actionName && target.classList.contains('none'))) {
                e.preventDefault();
                closeSelectHandler();
            }
        }
    };
    return (react_1.default.createElement(__1.Stack, __assign({ alignItems: "center", justifyContent: "space-between", className: AnvilSelectFooterClassNames, onKeyDown: handleKeyDown }, props),
        selectAll && (react_1.default.createElement(__1.BodyText, { size: "small", subdued: true },
            "Select",
            react_1.default.createElement(__1.Link, { primary: true, className: "m-l-1", onClick: onSelectAllClick },
                react_1.default.createElement("span", { ref: selectAllRef, tabIndex: 0, className: "Select__focus all" }, "All")),
            react_1.default.createElement(__1.Link, { primary: true, className: "m-l-1", onClick: onSelectNoneClick },
                react_1.default.createElement("span", { ref: selectNoneRef, tabIndex: 0, className: "Select__focus none" }, "None")))),
        hasAction && (react_1.default.createElement(__1.Button, { primary: true, xsmall: true, onClick: handleOnActionClick, className: "Select__focus m-l-auto", tabIndex: 0 }, actionName))));
});
//# sourceMappingURL=SelectFooter.js.map